import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { BOOKING_URL } from '../config/booking';

const Contact = () => {
  return (
    <div className="bg-black min-h-screen pt-20">
      {/* Hero */}
      <section className="relative h-[60vh] flex items-center justify-center text-white">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBneW18ZW58MHx8fHwxNzYyODY5NDgyfDA&ixlib=rb-4.1.0&q=85"
            alt="Kontakt"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-6 uppercase">
            Kontakt
          </h1>
          <p className="text-xl text-white/90">
            Wir freuen uns auf Ihren Besuch. Buchen Sie online einen Termin für ein kostenloses Beratungsgespräch.
          </p>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Contact Information */}
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold mb-8 text-black">
                Besuchen Sie uns
              </h2>
              <div className="space-y-6 mb-12">
                <div className="flex items-start gap-4">
                  <MapPin className="w-6 h-6 text-black flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-black mb-1">Adresse</h3>
                    <p className="text-black/70">
                      POSITIV Fitness Wolnzach GmbH<br />
                      Preysingstraße 64<br />
                      85283 Wolnzach
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Phone className="w-6 h-6 text-black flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-black mb-1">Telefon</h3>
                    <p className="text-black/70">+49 (0) 8442 677300</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Mail className="w-6 h-6 text-black flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-black mb-1">E-Mail</h3>
                    <p className="text-black/70">wolnzach@positiv-gruppe.de</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Clock className="w-6 h-6 text-black flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-black mb-1">Öffnungszeiten</h3>
                    <p className="text-black/70">
                      Montag - Freitag: 6:00 - 24:00 Uhr<br />
                      Samstag - Sonntag: 8:00 - 20:00 Uhr
                    </p>
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="aspect-video w-full bg-black/5 rounded-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps?q=Preysingstra%C3%9Fe%2064%2C%2085283%20Wolnzach&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="POSITIV Wolnzach Standort"
                ></iframe>
              </div>
            </div>

            {/* Terminbuchung */}
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold mb-8 text-black">
                Termin buchen
              </h2>
              <p className="text-black/70 mb-8 leading-relaxed">
                Ob Probetraining, Beratungsgespräch oder Fragen zur Mitgliedschaft:
                Buchen Sie Ihren Wunschtermin einfach online.
              </p>
              <Button
                asChild
                size="lg"
                className="w-full bg-black text-white hover:bg-black/90 h-12"
              >
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
                  Termin online buchen
                </a>
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-black text-white py-24">
        <div className="max-w-4xl mx-auto text-center px-6">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Bereit loszulegen?
          </h2>
          <p className="text-xl text-white/80 mb-8">
            Vereinbaren Sie noch heute ein kostenloses Probetraining und erleben Sie POSITIV selbst.
          </p>
          <Button 
            size="lg" 
            className="bg-white text-black hover:bg-white/90 h-12 px-8"
            asChild
          >
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
              Probetraining buchen
            </a>
          </Button>
        </div>
      </section>

    </div>
  );
};

export default Contact;
